import PropTypes from 'prop-types';
import { Text } from './Text';

export const YesNo = (props) => {
  let value;
  if (typeof props === 'boolean') {
    value = props;
  } else if (typeof props.cell.value === 'boolean') {
    value = props.cell.value;
  } else {
    // eslint-disable-next-line no-console
    console.error('Value provided for `YesNo` cell component is not accepted');
  }

  switch (value) {
    case true:
      return Text('Yes');
    case false:
      return Text('No');
    default:
      return '';
  }
};

YesNo.propTypes = {
  cell: PropTypes.object,
};
